export default {
	"7ff8b47d09de677578865f94280a2ea3": "下单页",
	"4563606279cf60875f81850e41f27854": "扩科商品曝光",
	"267203bcd5d649d97969b007ce2c78a1": "扩科选择按钮",
	"8168a28c7a3d47e4e6f6a677ca145277": "扩科换一换",
	"cba9a8373ad9a1cb95d95ff1f84ce84a": "换一换"
}
